import { getFileExtensionFromName } from '../../../../services/dataFormatting/getFileExtensionFromName';
import { getFileNameWithoutExtensionFromName } from '../../../../services/dataFormatting/getFileNameWithoutExtensionFromName';

export const getDocumentNameWithExtensionInLowercase = (documentName) => {
  let filExtension = '';
  let fileNameWithoutExtension = '';

  filExtension = getFileExtensionFromName(documentName);
  fileNameWithoutExtension = getFileNameWithoutExtensionFromName(documentName);

  return `${fileNameWithoutExtension}.${filExtension.toLowerCase()}`;
};
